/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from "react";
// @ts-ignore
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import api from "api";
import { Store, UpdateStore } from "StoreContext";
import { useLocation } from "react-router-dom";
import Loader from "components/Spinner/Spinner";
import "../../assets/css/mapbox.css";
import FilterIcon from "../../assets/img/filter_alt.svg";
import CalenderIcon from "../../assets/img/date_range.svg";
import BlueDot from "../../assets/img/blue-table-dot.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "../../assets/css/table.css";
const AccessTOKEN =
    "pk.eyJ1IjoiemlnemFnZ2VkMDQxMCIsImEiOiJjbTJrbmRqajUwMzQxMmxwejAzNzBqcWJvIn0.uETYRUCiTVjL1bGo-o5JHw";
// const AccessTOKEN = "";
mapboxgl.accessToken = AccessTOKEN;

const CitiesMapBox = ({ stateName, fullstateName, brandId, orderId, batchId }) => {

    const mapContainerRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const { user, usaFilter } = Store();
    const updateStore = UpdateStore();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [mapCitiesData, setMapCitiesdata] = useState(null);
    const [mapCountryData, setMapCountrydata] = useState([]);
    const [filterType, setFilterType] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const buttons = ["today", "yesterday", "this Month", "this Year"];
    const handleButtonClick = (button) => {
        setFilterType(button);
        setStartDate(null);
        setEndDate(null);
        updateStore({
            usaFilter: { filterType: button, startDate: null, endDate: null },
        });
    };
    console.log("mapCitiesData", mapCitiesData)

    const [citiesData, setCitiesData] = useState(null);

    useEffect(() => {
        if (usaFilter) {
            setStartDate(usaFilter.startDate);
            setEndDate(usaFilter.endDate);
            setFilterType(usaFilter.filterType);
        }
    }, []);

    function getColorByPercentage(percentage) {
        let color;
        if (percentage = 1) {
            color = "#aecaf2"; // Very light blue
            // color = "red"; // Very light blue 
        } else if (percentage > 1 && percentage <= 5) {
            color = "#9dbeed"; // Very light blue
            // color = "red"; // Very light blue 
        } else if (percentage > 5 && percentage <= 10) {
            color = "#91b4e5"; // Light blue
        } else if (percentage > 10 && percentage <= 15) {
            color = "#b2c4dd"; // Light pastel blue
        } else if (percentage > 15 && percentage <= 20) {
            color = "#8aaddf"; // Light lavender
        } else if (percentage > 20 && percentage <= 25) {
            color = "#a2b9d9"; // Soft lavender
        } else if (percentage > 25 && percentage <= 30) {
            color = "#9eb8db"; // Lavender
        } else if (percentage > 30 && percentage <= 35) {
            color = "#96b3da"; // Lighter purple
        } else if (percentage > 35 && percentage <= 40) {
            color = "#8eaed9"; // Soft purple
        } else if (percentage > 40 && percentage <= 45) {
            color = "#8aacda"; // Pastel purple
        } else if (percentage > 45 && percentage <= 50) {
            color = "#81a6d9"; // Medium purple
        } else if (percentage > 50 && percentage <= 55) {
            color = "#7ba3d9"; // Purple
        } else if (percentage > 55 && percentage <= 60) {
            color = "#759ed6"; // Slightly darker purple
        } else if (percentage > 60 && percentage <= 65) {
            color = "#6c97d1"; // Medium-dark purple
        } else if (percentage > 65 && percentage <= 70) {
            color = "#6894d0"; // Dark purple
        } else if (percentage > 70 && percentage <= 75) {
            color = "#638ec9"; // Deeper blue-purple
        } else if (percentage > 75 && percentage <= 80) {
            color = "#5c89c7"; // Deep blue
        } else if (percentage > 80 && percentage <= 85) {
            color = "#5684c4"; // Stronger blue
        } else if (percentage > 85 && percentage <= 90) {
            color = "#517fc0"; // Intense blue
        } else if (percentage > 90 && percentage <= 95) {
            color = "#4977b9"; // Almost dark blue
        } else if (percentage > 95 && percentage <= 100) {
            color = "#0c2d5a"; // Dark blue
        } else {
            // Default or invalid percentage
            color = "#ffffff"; // Fallback to white
        }

        return color;
    }
    useEffect(() => {
        getMapData();
    }, [filterType, startDate, endDate, brandId, orderId, batchId]);

    function getCitiesByState(data) {
        if (!stateName) {
            return []
        }
        const stateData = data.find(item => item.state == stateName);

        return stateData?.cities;
    }

    const getMapData = async () => {
        try {
            setLoading(true);
            let queryUrl = `/codes/scan-stats/map`;
            const queryParams = [];
            if (location.pathname.includes("brand")) queryParams.push(`brandId=${user._id}`);
            else if (brandId) queryParams.push(`brandId=${brandId}`);
            if (usaFilter?.startDate)
                queryParams.push(`startDate=${usaFilter?.startDate}`);
            if (usaFilter?.endDate) queryParams.push(`endDate=${usaFilter?.endDate}`);
            if (usaFilter?.filterType)
                queryParams.push(`filterType=${usaFilter?.filterType}`);
            if (orderId) queryParams.push(`orderId=${orderId}`);
            if (batchId) queryParams.push(`requestId=${batchId}`);
            if (queryParams.length > 0) {
                queryUrl += `?${queryParams.join("&")}`;
            }
            const res = await api("get", queryUrl);
            const citiesArray = getCitiesByState(res?.statesData || [])
            setMapCitiesdata(citiesArray)
            setMapCountrydata(res?.countryData || []);
            setTimeout(() => {

                setLoading(false);
            }, 1000);
        } catch (err) {
            setLoading(false);
            console.error(err);
        }
    };

    async function getCityBoundaries(stateName, cityName) {
        try {
            // Transform state and city names to lowercase and separate with hyphens
            const formattedStateName = stateName.toLowerCase();
            const formattedCityName = cityName.toLowerCase().replace(/\s+/g, '-');

            // Construct the URL
            const url = `https://raw.githubusercontent.com/generalpiston/geojson-us-city-boundaries/refs/heads/master/cities/${formattedStateName}/${formattedCityName}.json`;

            // Fetch the GeoJSON data
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Unable to fetch data for ${cityName}, ${stateName}. HTTP Status: ${response.status}`);
            }
            const geoJsonData = await response.json();

            // Ensure the GeoJSON data has the required structure for Mapbox
            if (!geoJsonData.features || geoJsonData.features.length === 0) {
                console.log(`No features found for ${cityName}, ${stateName}.`)
            }

            // Extract and format data
            const formattedGeoJson = {
                type: "FeatureCollection",
                features: geoJsonData.features.map((feature) => ({
                    type: "Feature",
                    geometry: feature.geometry,
                    properties: feature.properties || {}, // Include any additional properties
                })),
            };

            return formattedGeoJson; // Return GeoJSON formatted data
        } catch (error) {
            console.error("Error fetching city boundaries:", error);
            return null; // Return null in case of an error
        }
    }

    const getCityNameFromCoordinates = async (longitude, latitude) => {
        const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${AccessTOKEN}`;

        try {
            const response = await fetch(url);
            const data = await response.json();
            if (data.features && data.features.length > 0) {
                const city = data.features.find((feature) => feature.place_type.includes('place'));
                if (city) {
                    return city.text; // The name of the city
                }
            }
            return null; // No city found
        } catch (error) {
            console.error('Error getting city name:', error);
            return null;
        }
    };
    useEffect(() => {
        const fetchCityName = async () => {
            await getCityNameFromCoordinates();
        };
        fetchCityName();

    }, []);

    useEffect(() => {
        // Fetch the cities GeoJSON data
        const fetchCitiesData = async () => {
            try {
                const citiesResponse = await fetch(
                    "https://raw.githubusercontent.com/ResidentMario/geoplot-data/refs/heads/master/usa-cities.geojson"
                );
                const citiesGeoJson = await citiesResponse.json();
                setCitiesData(citiesGeoJson);
            } catch (error) {
                console.error("Error fetching cities data:", error);
            }
        };

        fetchCitiesData();
    }, []);

    useEffect(() => {
        const fetchGeoJson = async () => {
            try {
                if (mapContainerRef.current) {
                    // Initialize the map
                    if (mapInstanceRef.current) {
                        mapInstanceRef.current.remove();
                    }

                    const mapInstance = new mapboxgl.Map({
                        container: mapContainerRef.current,
                        style: "mapbox://styles/mapbox/light-v10",
                        center: [-98.5795, 39.8283], // Center of the US
                        zoom: window.innerWidth < 768 ? 3 : 4,
                        maxZoom: window.innerWidth < 768 ? 8 : 10,
                        minZoom: window.innerWidth < 768 ? 3 : 4,
                        attributionControl: false,
                    });

                    mapInstanceRef.current = mapInstance;

                    // Fetch the state boundaries GeoJSON data
                    const statesResponse = await fetch(
                        "https://raw.githubusercontent.com/PublicaMundi/MappingAPI/master/data/geojson/us-states.json"
                    );
                    const statesGeoJson = await statesResponse.json();

                    mapInstance.on("load", async () => {
                        // Hide all default layers (labels, roads, etc.)
                        mapInstance.getStyle().layers.forEach((layer) => {
                            if (layer.type !== "background") {
                                mapInstance.setLayoutProperty(layer.id, "visibility", "none");
                            }
                        });

                        // Set the map background color to white
                        mapInstance.addLayer({
                            id: "background",
                            type: "background",
                            paint: { "background-color": "#ffffff" },
                        });

                        // Add state boundaries to the map
                        mapInstance.addSource("states", {
                            type: "geojson",
                            data: statesGeoJson,
                        });

                        mapInstance.addLayer({
                            id: "state-boundaries",
                            type: "fill",
                            source: "states",
                            paint: {
                                // Default all states to white, only selected state to gray
                                "fill-color": [
                                    "case",
                                    ["==", ["get", "name"], fullstateName], // Check if state matches selected
                                    "#a49e9c", // Gray for selected state
                                    "#f7ebe7", // White for all other states
                                ],
                                "fill-opacity": 0.2,
                            },
                        });

                        // If city data is available, filter cities for the selected state
                        if (citiesData) {
                            const stateCities = citiesData.features.filter(
                                (city) => city.properties.STATE === stateName
                            );

                            // Modify the cities data to replace abbreviations with full state names
                            const updatedCitiesData = await Promise.all(
                                stateCities.map(async (city) => {
                                    const coordinates = city.geometry.coordinates;
                                    const cityName = await getCityNameFromCoordinates(coordinates[0], coordinates[1]);
                                    return {
                                        ...city,
                                        properties: {
                                            ...city.properties,
                                            STATE: fullstateName,
                                            city: cityName, // You can include city name here
                                        },
                                    };
                                })
                            );
                            const updatedCitiesData2 = await Promise.all(
                                stateCities.map(async (city) => {
                                    const coordinates = city.geometry.coordinates;
                                    const cityName = await getCityNameFromCoordinates(coordinates[0], coordinates[1]);
                                    // Fetch boundaries for the city
                                    const cityBoundaries = await getCityBoundaries(stateName, cityName);

                                    return {
                                        ...city,
                                        geometry: cityBoundaries ? cityBoundaries.features[0]?.geometry : city.geometry, // Update geometry if boundaries are found
                                        properties: {
                                            ...city.properties,
                                            STATE: fullstateName, // Ensure full state name is added
                                            city: cityName,        // Include city name in properties
                                        },
                                    };
                                })
                            );

                            // Create a GeoJSON FeatureCollection for the filtered cities
                            const cityBoundariesGeoJSON = {
                                type: "FeatureCollection",
                                features: updatedCitiesData2,
                            };

                            // Add a source for city boundaries
                            mapInstance.addSource("city-boundaries", {
                                type: "geojson",
                                data: cityBoundariesGeoJSON,
                            });

                            // Add a line layer for city borders
                            mapInstance.addLayer({
                                id: "city-borders",
                                type: "line",
                                source: "city-boundaries",
                                paint: {
                                    "line-color": "white", // Black color for city borders
                                    "line-width": 1, // Border width
                                },
                            });
                            mapInstance.addLayer({
                                id: 'city-boundaries-fill',
                                type: 'fill', // Fill to represent city boundaries
                                source: 'city-boundaries',
                                layout: {},
                                paint: {
                                    'fill-color': 'white',  // Set fill color gray
                                    'fill-opacity': 0.8,     // Set fill opacity
                                },
                            });
                            mapCitiesData?.forEach((city) => {
                                const cityName = city.cityname || city.city;
                                const validCode = city.validCode ?? city.totalCodes;
                                // Find the corresponding city boundaries in your map data
                                const cityFeature = updatedCitiesData2.find(
                                    (feature) => feature.properties.city === cityName
                                );

                                if (cityFeature) {
                                    const colorIs = getColorByPercentage(validCode)
                                    // Add a layer to style cities based on validCode
                                    mapInstance.addLayer({
                                        id: `city-fill-${cityName}`,
                                        type: 'fill',
                                        source: 'city-boundaries',
                                        filter: ['==', ['get', 'city'], cityName], // Match the city name
                                        paint: {
                                            'fill-color': validCode ? colorIs : 'white', // Red if validCode exists
                                            'fill-opacity': 0.5,
                                        },
                                    });
                                }
                            });
                            // Setup popup
                            const popup = new mapboxgl.Popup({
                                closeButton: false,
                                closeOnClick: false,
                            });

                            mapInstance.on('mousemove', 'city-boundaries-fill', (e) => {
                                const cityName = e.features[0]?.properties.city; // Get city name from the hovered feature
                                const matchedCity = mapCitiesData?.find((city) => (city.cityname || city.city) === cityName);
                                const validCode = matchedCity?.validCode ?? matchedCity?.totalCodes;

                                if (cityName) {
                                    mapInstance.getCanvas().style.cursor = 'pointer'; // Change cursor to pointer
                                    const coordinates = e.lngLat;
                                    popup
                                        .setLngLat(coordinates)
                                        .setHTML(
                                            `<strong>${cityName}</strong>${validCode ? `<br>Valid Code: ${validCode}` : ''}`
                                        )
                                        .addTo(mapInstance);

                                }
                            });
                            mapInstance.on("mouseleave", "city-boundaries-fill", () => {
                                popup.remove();
                            });

                            // Adjust the map to fit all the city markers
                            const bounds = new mapboxgl.LngLatBounds();
                            updatedCitiesData.forEach((city) => {
                                bounds.extend(city.geometry.coordinates);
                            });
                            mapInstance.fitBounds(bounds, { padding: 50 });
                        }
                    });
                }
            } catch (error) {
                console.error("Error fetching or displaying map data:", error);
            }
        };

        fetchGeoJson();

        return () => {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
        };
    }, [stateName, mapCitiesData]);


    const handleStartDate = (date) => {
        setStartDate(date);
        setFilterType("");
        updateStore({
            usaFilter: { ...usaFilter, filterType: "", startDate: date },
        });
    };
    const handleEndDate = (date) => {
        setEndDate(date);
        setFilterType("");
        updateStore({
            usaFilter: { ...usaFilter, filterType: "", endDate: date },
        });
    };

    const sortCityData = (mapStatesData) => {
        return (
            mapStatesData.sort((a, b) => b.validCode - a.validCode)
        );
    };

    return (
        <div className="mapbox-main">
            <div className="inner-country-data">
                <div className="FilterBy-trade-main">
                    <div className="FilterBy-trade-iner-1">
                        <img src={FilterIcon} alt="filter Icon" />
                        <h2>Filter By Date</h2>
                    </div>
                    <div className="FilterBy-trade-iner-2">
                        <div className="start-date-main">
                            <div className="startdate-input-1">
                                <label>Start Date</label>
                                <div className="input-div">
                                    <img
                                        src={CalenderIcon}
                                        alt="calendar icon"
                                        onClick={() =>
                                            document.getElementById("start-date-picker").focus()
                                        }
                                        style={{ cursor: "pointer" }}
                                    />
                                    <DatePicker
                                        id="start-date-picker"
                                        selected={startDate}
                                        onChange={(date) => handleStartDate(date)}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="mm/dd/yyyy"
                                        className="custom-datepicker"
                                        popperClassName="custom-datepicker-pooper"
                                    />
                                </div>
                            </div>
                            <div className="startdate-input-1">
                                <label>End Date</label>
                                <div className="input-div">
                                    <img
                                        src={CalenderIcon}
                                        alt="calendar icon"
                                        onClick={() =>
                                            document.getElementById("end-date-picker").focus()
                                        }
                                        style={{ cursor: "pointer" }}
                                    />
                                    <DatePicker
                                        id="end-date-picker"
                                        selected={endDate}
                                        onChange={(date) => handleEndDate(date)}
                                        dateFormat="MM/dd/yyyy"
                                        placeholderText="mm/dd/yyyy"
                                        className="custom-datepicker"
                                        popperClassName="custom-datepicker-pooper"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="preset-main start-date-main">
                            {buttons.map((button, index) => (
                                <button
                                    key={index}
                                    className={`date-button ${filterType === button ? "active" : ""
                                        }`}
                                    onClick={() => handleButtonClick(button)}
                                >
                                    {button}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="table-con-main">
                    {/* Top US States */}
                    <div className="custom-table">
                        <div className="table-header">
                            <h2 className="vs-section-title">Top Cities</h2>
                        </div>
                        <div className="table-body">
                            {mapCitiesData?.length > 0 ? (
                                sortCityData(mapCitiesData).map((state, index) => (
                                    <div className="table-row" key={index}>
                                        <div className="dot-row">
                                            <img src={BlueDot} alt="dot" />
                                            {String(state.cityname || state.city || state.state || '')}
                                        </div>
                                        <div className="td-2">{(state.validCode ?? state.totalCodes)?.toLocaleString() || "N/A"}</div>
                                    </div>
                                ))
                            ) : (
                                <div className="table-row">
                                    <div colSpan={2}>No data available for cities.</div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Top Countries */}
                    <div className="custom-table custom-table2">
                        <div className="table-header">
                            <h2 className="vs-section-title">Top Countries</h2>
                        </div>
                        <div className="table-body">
                            {mapCountryData.length > 0 ? (
                                mapCountryData.map((country, index) => (
                                    <div className="table-row" key={index}>
                                        <div className="dot-row">
                                            <img src={BlueDot} alt="dot" />
                                            {String(country.name || country.country || '')}
                                        </div>
                                        <div className="td-2">{country.percentage || "N/A"}%</div>
                                    </div>
                                ))
                            ) : (
                                <div className="table-row">
                                    <div colSpan={2}>No data available for countries.</div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="mapbox-map-container"
            >
                {loading ? (
                    <div
                        className="mapbox-map-loader"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#fff",
                            borderRadius: "10px",
                            zIndex: 2,
                        }}
                    >
                        <Loader />
                    </div>
                ) : null}
                <div
                    ref={mapContainerRef}
                    style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "10px",
                        visibility: loading ? "hidden" : "visible",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        backgroundColor: "#ffffff",
                    }}
                />
            </div>
        </div>
    );
};

export default CitiesMapBox;
